import Bg from "./images/carrearBg.jpg";
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { scrollToBottom } from '../../utils';
import React, { useState,useEffect } from 'react';
import { sendApplication } from '../../actions/career';
import { Grid, Typography, Button, TextField, Box, Paper, Container, Divider } from '@mui/material';

const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  const onSubmit = data => {
    const formdata = new FormData();
    Object.keys(data).forEach(key => {
      formdata.append(key, data[key]);
    });
    formdata.append('resume', file);
    dispatch(sendApplication({ data: formdata }));
  };

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  return (
    <Grid >
      {/* Keep the original header section unchanged */}
       <div className="relative h-[35vh] sm:h-[40vh] md:h-[50vh] lg:h-[60vh] flex items-center justify-center overflow-hidden mb-8 md:mb-12 px-4">
              {/* Background Image */}
              <div
                className="absolute inset-0 bg-contain bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${Bg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                }}
              ></div>
      
              {/* Yellow/Green Overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-blue-400/60 via-blue-500/50 to-green-600/40"></div>
      
              {/* Heading */}
              <h1
                className="relative text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tracking-wider z-10 text-center px-4 max-w-full break-words"
                style={{
                  textShadow: "4px 4px 8px rgba(0,0,0,0.5), 0 0 20px rgba(0,0,0,0.3)",
                  fontFamily: "Arial Black, sans-serif",
                  letterSpacing: "0.05em",
                  wordWrap: "break-word",
                  hyphens: "auto",
                }}
              >
                Happy Adventuring
              </h1>
            </div>

      {/* Enhanced Life at Funingo Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            borderRadius: 3,
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            mb: 5
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '28px', md: '36px' },
              fontWeight: '700',
              textAlign: 'center',
              mb: 4,
              color: '#2c3e50',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '60px',
                height: '4px',
                backgroundColor: '#3498db',
                borderRadius: '2px'
              }
            }}
          >
            Life at Funingo
          </Typography>
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box 
                sx={{ 
                  p: 3, 
                  backgroundColor: 'rgba(255,255,255,0.8)', 
                  borderRadius: 2,
                  height: '100%',
                  border: '2px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    border: '2px solid #3498db',
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(52, 152, 219, 0.2)'
                  }
                }}
              >
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    mb: 2,
                    color: '#2c3e50'
                  }}
                >
                  🎯 Our Values
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: '#34495e'
                  }}
                >
                  At FUNINGO, we don't just offer jobs, we invite you to become part of
                  a vibrant community that thrives on values, ethics, and, most
                  importantly, fun! Imagine a workplace where the pursuit of excitement
                  is matched only by a commitment to integrity.
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Box 
                sx={{ 
                  p: 3, 
                  backgroundColor: 'rgba(255,255,255,0.8)', 
                  borderRadius: 2,
                  height: '100%',
                  border: '2px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    border: '2px solid #e74c3c',
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(231, 76, 60, 0.2)'
                  }
                }}
              >
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    mb: 2,
                    color: '#2c3e50'
                  }}
                >
                  🚀 Growth & Adventure
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: '#34495e'
                  }}
                >
                  We believe in fostering an environment where every team member can
                  grow both professionally and personally, all while relishing the joy
                  of their work. Here, adventure isn't just an attraction; it's a way of
                  life that compliments our values and infuses every task with
                  enthusiasm.
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Box 
                sx={{ 
                  p: 3, 
                  backgroundColor: 'rgba(255,255,255,0.8)', 
                  borderRadius: 2,
                  height: '100%',
                  border: '2px solid transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    border: '2px solid #27ae60',
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 30px rgba(39, 174, 96, 0.2)'
                  }
                }}
              >
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    mb: 2,
                    color: '#2c3e50'
                  }}
                >
                  💎 Benefits & Perks
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: '#34495e'
                  }}
                >
                  Plus, we pride ourselves on providing a comprehensive benefits
                  package, including competitive salaries, health and wellness programs,
                  and unique perks that make working here not just a job, but an
                  enriching experience.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Enhanced Application Form Section */}
        <Paper 
          elevation={4} 
          sx={{ 
            p: 5, 
            borderRadius: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: '24px', md: '32px' },
                fontWeight: '600',
                mb: 2
              }}
            >
              Can't find what you are looking for?
            </Typography>
            <Typography 
              sx={{ 
                fontSize: '18px', 
                opacity: 0.9,
                mb: 3
              }}
            >
              Don't worry! Send us your details and we'll get back to you when the perfect opportunity arises.
            </Typography>
            <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.3)', width: '100px', mx: 'auto' }} />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Paper 
              elevation={2}
              sx={{ 
                p: 4, 
                borderRadius: 3, 
                width: '100%', 
                maxWidth: '500px',
                backgroundColor: 'rgba(255,255,255,0.95)'
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Full Name*
                  </Typography>
                  <TextField
                    fullWidth
                    {...register('name', { required: 'Name is required' })}
                    placeholder='John Doe'
                    error={!!errors?.name}
                    helperText={errors?.name?.message}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Email Address*
                  </Typography>
                  <TextField
                    fullWidth
                    {...register('email', { required: 'Email is required' })}
                    placeholder='john@email.com'
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Phone Number*
                  </Typography>
                  <TextField
                    fullWidth
                    {...register('phone_no', {
                      required: 'Phone Number is required'
                    })}
                    placeholder='79999XXXXX'
                    error={!!errors?.phone_number}
                    helperText={errors?.phone_number?.message}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Location*
                  </Typography>
                  <TextField
                    fullWidth
                    {...register('location', { required: 'Location is required' })}
                    placeholder='Eg. Jabalpur, Madhya Pradesh'
                    error={!!errors?.location}
                    helperText={errors?.location?.message}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Highest Qualification*
                  </Typography>
                  <TextField
                    fullWidth
                    {...register('highest_qualification', {
                      required: 'Highest Qualification is required'
                    })}
                    placeholder='Eg. Graduation'
                    error={!!errors?.highest_qualification}
                    helperText={errors?.highest_qualification?.message}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <Typography sx={{ color: '#2c3e50', fontWeight: '500', mb: 1 }}>
                    Resume / CV
                  </Typography>
                  <TextField 
                    type='file' 
                    onChange={handleFileChange}
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#3498db',
                        },
                      },
                    }}
                  />
                  {file && (
                    <Typography 
                      sx={{ 
                        mt: 1, 
                        fontSize: '14px', 
                        color: '#27ae60',
                        fontWeight: '500'
                      }}
                    >
                      ✓ {file.name} selected
                    </Typography>
                  )}
                </Grid>
                
                <Grid item xs={12}>
                  <Button
                    variant='contained'
                    fullWidth
                    size="large"
                    onClick={handleSubmit(onSubmit)}
                    sx={{
                      mt: 2,
                      py: 1.5,
                      borderRadius: 2,
                      fontSize: '16px',
                      fontWeight: '600',
                      textTransform: 'none',
                      background: 'linear-gradient(45deg, #3498db 30%, #2980b9 90%)',
                      boxShadow: '0 6px 20px rgba(52, 152, 219, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #2980b9 30%, #1f5f8b 90%)',
                        boxShadow: '0 8px 25px rgba(52, 152, 219, 0.4)',
                        transform: 'translateY(-2px)'
                      }
                    }}
                  >
                    Submit Application
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Paper>
      </Container>
    </Grid>
  );
};

export default Careers;
